import styled from "@emotion/styled";

export const Details = styled("div")({
  marginBottom: 24,
  display: "flex",
  flexDirection: "column",
  gap: 24,
});

export const DetailsTitle = styled("span")({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "1rem",
  fontWeight: 600,
  lineHeight: "24px",
});
